<template>
<div class="cssHead">{{ $t("overlay.css_colors") }}</div>
<pre>#holder {
  <span class="comment">/* Pink */</span>
  --color1: #387aff;
  <span class="comment">/* Pink faded */</span>
  --color1-fade: #387aff33;
  <span class="comment">/* Blue */</span>
  --color2: #f50e9b;
  <span class="comment">/* Blue faded */</span>
  --color2-fade: #f50e9b33;
  <span class="comment">/* Timer color */</span>
  --colorProgress: #387aff;
  <span class="comment">/* Values text color (votes, percents, ...) */</span>
  --value-text: #000000;
  <span class="comment">/* Values background (votes, percents, ...) */</span>
  --value-bg: rgba(0, 0, 0, .5);
  <span class="comment">/* Background window color */</span>
  background-color: #ffffff;
}</pre>
</template>